import React from "react";
import Select from "react-select";
import { OPTION_LABELS } from "../../../config/lang";
import { translate } from "../../../util/util";

export default function ChipsField({ field, value, onChange, lang }) {
  // Localize option display labels (keyed by value); fall back to the raw label.
  const opts = (field.options || []).map(o => ({ ...o, label: translate(OPTION_LABELS, String(o.value), lang) || o.label }));
  const selected = opts.filter(o => (value || []).includes(o.value));
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}</label>
      <Select
        isMulti
        className="mp-select"
        options={opts}
        value={selected}
        onChange={list => onChange(field.name, (list || []).map(o => o.value))}
      />
    </div>
  );
}
